import { render, staticRenderFns } from "./quickReservationDialog.vue?vue&type=template&id=4806ea51&scoped=true"
import script from "./quickReservationDialog.vue?vue&type=script&lang=js"
export * from "./quickReservationDialog.vue?vue&type=script&lang=js"
import style0 from "./quickReservationDialog.vue?vue&type=style&index=0&id=4806ea51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4806ea51",
  null
  
)

export default component.exports